'use strict'
const env = process.env.NODE_ENV === 'production' ? true : false

const Index = env ? resolve => require(['@/views/mg/index/Index.vue'], resolve) : require('@/views/mg/index/Index.vue')
const Business = env ? resolve => require(['@/views/mg/business/Index.vue'], resolve) : require('@/views/mg/business/Index.vue')
const BusinessManage = env ? resolve => require(['@/views/mg/business/BusinessManage.vue'], resolve) : require('@/views/mg/business/BusinessManage.vue')
const BusinessEdit = env ? resolve => require(['@/views/mg/business/BusinessEdit.vue'], resolve) : require('@/views/mg/business/BusinessEdit.vue')
const Message = env ? resolve => require(['@/views/mg/message/Index.vue'], resolve) : require('@/views/mg/message/Index.vue')
const MessageList = env ? resolve => require(['@/views/mg/message/MessageList.vue'], resolve) : require('@/views/mg/message/MessageList.vue')
const MessageEdit = env ? resolve => require(['@/views/mg/message/MessageEdit.vue'], resolve) : require('@/views/mg/message/MessageEdit.vue')


const routers = [{
	name: 'mgIndex',
	path: 'index',
	meta: {
		active: 'mgIndex'
	},
	component: Index
}, {
	name: 'mgBusiness',
	path: 'business',
	meta: {
		active: 'mgBusiness'
	},
	component: Business,
	children: [{
			path: '',
			meta: {
				active: 'mgBusiness'
			},
			component: BusinessManage
		},
		{
			name: 'businessManage',
			path: 'manage',
			meta: {
				active: 'mgBusiness'
			},
			component: BusinessManage
		},
	]
}, {
	name: 'businessEdit',
	path: 'businessEdit',
	meta: {
		active: 'mgBusiness'
	},
	component: BusinessEdit
},{
	name: 'mgMessage',
	path: 'message',
	meta: {
		active: 'mgMessage'
	},
	component: Message,
	children: [{
			path: '',
			meta: {
				active: 'mgMessage'
			},
			component: MessageList
		},
		{
			name: 'mgMessageList',
			path: 'manageList',
			meta: {
				active: 'mgMessage'
			},
			component: MessageList
		},
	]
}, {
	name: 'mgMessageEdit',
	path: 'messageEdit',
	meta: {
		active: 'mgMessage'
	},
	component: MessageEdit
}, ]

export default routers


// WEBPACK FOOTER //
// ./src/router/mg.js